import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Brain, ArrowRight, AlertTriangle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface BiasReflectionData {
  initial_preference: 'a' | 'b';
  initial_preference_label: string;
  recommendation_matches: boolean;
  reflection_text: string;
}

interface BiasReflectionBlockProps {
  data?: BiasReflectionData | null;
  recommendedOptionLabel?: string;
}

export const BiasReflectionBlock = ({ data, recommendedOptionLabel }: BiasReflectionBlockProps) => {
  if (!data || !data.initial_preference) return null;

  const matches = data.recommendation_matches;

  return (
    <Card className={cn(
      "border",
      matches
        ? "border-orange-500/20 bg-orange-500/[0.03]"
        : "border-primary/20 bg-primary/[0.03]"
    )}>
      <CardContent className="p-5 space-y-4">
        <div className="flex items-center gap-3">
          <div className={cn(
            "flex h-9 w-9 items-center justify-center rounded-lg",
            matches ? "bg-orange-500/10" : "bg-primary/10"
          )}>
            <Brain className={cn(
              "h-5 w-5",
              matches ? "text-orange-600 dark:text-orange-400" : "text-primary"
            )} />
          </div>
          <div>
            <h3 className="font-semibold text-sm text-foreground">
              Bias-Reflexion
            </h3>
            <p className="text-xs text-muted-foreground">
              Initiale Tendenz vs. analytische Empfehlung
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 text-sm">
          <Badge variant="outline" className="text-xs">
            Initiale Tendenz: {data.initial_preference_label}
          </Badge>
          <ArrowRight className="h-3 w-3 text-muted-foreground shrink-0" />
          <Badge variant="outline" className="text-xs">
            Empfehlung: {recommendedOptionLabel || '–'}
          </Badge>
        </div>

        <div className={cn(
          "flex items-start gap-2 p-3 rounded-lg text-sm",
          matches
            ? "bg-orange-500/10 text-orange-900 dark:text-orange-200"
            : "bg-primary/10 text-foreground"
        )}>
          {matches ? (
            <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5 text-orange-600 dark:text-orange-400" />
          ) : (
            <CheckCircle2 className="h-4 w-4 shrink-0 mt-0.5 text-primary" />
          )}
          <p>{data.reflection_text}</p>
        </div>
      </CardContent>
    </Card>
  );
};
